import {NULL_SENTINEL} from "~/components/ottopilotDataViewer/filterComponentStupider";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {SYSTEM_USER_ID} from "@vesta/vos-types/generic/constants/SystemUserIds";

const deprecatedSystemGeneratedCreatedUpdatedByUserIdSet = new Set<string>(
    [SYSTEM_USER_ID],
);

export function isDeprecatedSystemGeneratedCreatedUpdatedByUserId(userId: unknown): boolean {
    if (typeof userId !== "string") {
        return false;
    }
    const normalized = userId.trim().toLowerCase();
    if (normalized === "") {
        return false;
    }
    return deprecatedSystemGeneratedCreatedUpdatedByUserIdSet.has(normalized);
}

export function normalizeCreatedUpdatedByUserIdForDisplay(userId: Uuid | null): Uuid | null {
    if (userId === null) {
        return null;
    }
    if (isDeprecatedSystemGeneratedCreatedUpdatedByUserId(userId) === true) {
        return null;
    }
    return userId;
}

export function isCreatedUpdatedByFilterColumnId(columnId: string): boolean {
    const normalized = String(columnId).trim().toLowerCase();
    return normalized === "createdby" || normalized === "updatedby";
}

export function sanitizeCreatedUpdatedByFilterColumnValues(
    columnId: string,
    values: Array<string>,
): Array<string> {
    if (isCreatedUpdatedByFilterColumnId(columnId) !== true) {
        return values;
    }

    const filteredValues = values.filter((value) => {
        if (value === NULL_SENTINEL) {
            return true;
        }
        if (isDeprecatedSystemGeneratedCreatedUpdatedByUserId(value) === true) {
            return false;
        }
        return true;
    });

    const removedDeprecatedId = filteredValues.length !== values.length;
    if (removedDeprecatedId === true && filteredValues.includes(NULL_SENTINEL) === false) {
        return [NULL_SENTINEL, ...filteredValues];
    }

    return filteredValues;
}
